/* eslint-disable react/react-in-jsx-scope */
import { Box, FormControlLabel, Radio, RadioGroup, Typography } from "@mui/material";
import "./chat-bubble.scss";

interface ChatBubbleProps {
  text?: string;
  isUser?: boolean; // if true → user bubble
  options?: string[];  // new prop for options
  onOptionSelect?: (option: string) => void;
  type?: string;
  isAnswered?: boolean;
  selectedOption?: string;
}

export default function ChatBubble({ text, isUser = false, options, onOptionSelect, type, isAnswered, selectedOption }: ChatBubbleProps) {
  const renderTextWithLinks = (text: string) => {
    const phoneRegex = /(\+?\d{10,15})/g;
    const emailRegex = /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g;

    // Split by both email and phone
    const combinedRegex = new RegExp(
      `${emailRegex.source}|${phoneRegex.source}`,
      "g"
    );

    const parts = text.split(combinedRegex);

    return parts.map((part, index) => {
      if (!part) return null;

      if (emailRegex.test(part)) {
        return (
          <a
            key={index}
            href={`mailto:${part}`}
            style={{
              color: "#15585D",
              fontWeight: 500,
              textDecoration: "underline",
            }}
          >
            {part}
          </a>
        );
      }

      if (phoneRegex.test(part)) {
        return (
          <a
            key={index}
            href={`tel:${part}`}
            style={{
              color: "#15585D",
              fontWeight: 500,
              textDecoration: "underline",
            }}
          >
            {part}
          </a>
        );
      }

      return <span key={index}>{part}</span>;
    });
  };
  return (
    <Box
      className={`chat-bubble-wrapper ${isUser ? "user" : "bot"}`}
      display="flex"
      justifyContent={isUser ? "flex-end" : "flex-start"}
      sx={{
        marginBottom: "4px !important",
      }}
    >
      <Box className={`chat-bubble ${isUser ? "user-bubble" : "bot-bubble"}`}>
        {options ? (
          <Box>
            <Typography variant="body1" className="chat-text">
              {type === "callConfirmation"
                ? "Did you receive call from MemorialGo?"
                : "Do you require Immediate Need Assistance or wish to explore Preneed Planning options?"}
            </Typography>
            <RadioGroup row
              value={selectedOption || ""}
              onChange={(e) => {
                if (!isAnswered) {
                  onOptionSelect?.(e.target.value);
                }
              }}
              sx={{
                gap: 2,            // 🔥 space between options
                flexWrap: "wrap",  // optional for smaller screens
                mb: "0 !important", // override MUI default margin
              }}>
              {options.map((option) => (
                <FormControlLabel
                  key={option}
                  value={option}
                  control={
                    <Radio
                      size="small"
                      disabled={isAnswered}
                      sx={{
                        "&.Mui-disabled": {
                          color: "inherit",
                          opacity: 0.5,
                          cursor: "not-allowed !important",
                          pointerEvents: "auto",
                        },
                      }}
                    />
                  }
                  label={option}
                  // onClick={() => onOptionSelect?.(option)}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    margin: 0,
                    cursor: isAnswered ? "not-allowed" : "pointer",
                    "& .Mui-disabled": {
                      cursor: "not-allowed !important",
                    },
                    // 🔥 Override MUI disabled label styling
                    "& .MuiFormControlLabel-label.Mui-disabled": {
                      color: "inherit",
                      opacity: 1,
                    },
                  }}
                />
              ))}
            </RadioGroup>
          </Box>
        ) : (
          <Typography variant="body1" className="chat-text" sx={{ whiteSpace: "pre-line" }} >
            {text && !isUser
              ? renderTextWithLinks(text)
              : text}
          </Typography>
        )}
      </Box>
    </Box>
  );
}
